import { defaultBrandSettings } from 'modules/white-label/constants/brand-settings'
import { sanitizeHostname } from './sanitize-hostname'

const getReferenceHostname = () => {
  const envHostname = sanitizeHostname(process.env.NEXT_PUBLIC_SIO_HOSTNAME)

  if (envHostname) {
    return envHostname
  }

  return sanitizeHostname(defaultBrandSettings.dashboardHostname)
}

export const isWhiteLabel = (dashboardHostname: string): boolean => {
  const referenceHostname = getReferenceHostname()

  if (!referenceHostname) {
    return false
  }

  const normalizedDomain = sanitizeHostname(dashboardHostname)

  if (!normalizedDomain) {
    return false
  }

  return normalizedDomain !== referenceHostname
}
